import { ExpansionPanels } from "@google/glue";
import "./accordion.scss";

const CSS_CLASSES = {
  expansionPanels: "glue-expansion-panels",
};

export class AccordionComponent {
  constructor() {
    this.init();
  }

  init() {
    this.initExpansionPanels();
  }

  initExpansionPanels() {
    const expansionPanelsContainerElements =
      document.querySelectorAll<HTMLDivElement>(
        `.${CSS_CLASSES.expansionPanels}`
      );
    if (!expansionPanelsContainerElements) return;

    expansionPanelsContainerElements.forEach(
      (expansionPanelsContainer: HTMLDivElement) => {
        if (expansionPanelsContainer) {
          new ExpansionPanels(expansionPanelsContainer);
        }
      }
    );
  }
}
